<div class="wrapper-container">
  <div class="container">
    <h2>{{ 'orderReturn.title' | cxTranslate }}</h2>
    <div class="d-flex flex-wrap justify-content-center">
      @if (categories$ | async; as category) {
        <form #frm (ngSubmit)="onSubmit()" class="w-75" [formGroup]="orderReturnForm">
          <div class="col-sm-12">
            <p class="subtitle">{{ 'orderReturn.description' | cxTranslate }}</p>
          </div>
          <div [class]="(validate | async) ? 'background-grey' : ''">
            <div class="col-sm-12 pr-0 form-group row">
              <div class="col-sm-6">
                <label>
                  <span class="label-content required mandatory">
                    {{ 'orderReturn.orderNumber' | cxTranslate }}
                  </span>
                  <input [readOnly]="validate | async" type="text" name="ticketOrderCode" class="form-control" formControlName="ticketOrderCode" />
                  <cx-form-errors [control]="orderReturnForm.get('ticketOrderCode')"></cx-form-errors>
                </label>
              </div>
              <div class="col-sm-6 pr-0">
                <div class="form-group">
                  <label>
                    <span class="label-content required mandatory">
                      {{ 'orderReturn.email' | cxTranslate }}
                    </span>
                    <input [readOnly]="validate | async" type="email" name="email" class="form-control" formControlName="email" />
                    <cx-form-errors [control]="orderReturnForm.get('email')"></cx-form-errors>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-sm-10">
              <div class="form-group">
                <label class="select-label">
                  <span class="label-content required mandatory">
                    {{ 'orderReturn.subject' | cxTranslate }}
                  </span>
                  <!--                  <ng-select-->
                  <!--                    (change)="categorySelected($event)"-->
                  <!--                    class="return-selector"-->
                  <!--                    formControlName="issueCategory"-->
                  <!--                    [clearable]="false">-->
                  <!--                  <ng-option *ngFor="let description of category.entities?.value?.issueCategories"-->
                  <!--                             [value]="description.code">-->
                  <!--                    {{description.description}}-->
                  <!--                  </ng-option>-->
                  <!--                  >-->
                  <!--                  </ng-select>-->
                  <select id="return-selector-id" formControlName="issueCategory" class="return-selector form-control filter-select" (change)="categorySelected($event)">
                    <option selected disabled value="">
                      {{ 'orderReturn.subject' | cxTranslate }}
                    </option>
                    @for (description of category.entities?.value?.issueCategories; track description) {
                      <option [value]="description.code">
                        {{ description.description }}
                      </option>
                    }
                  </select>
                  <!--                  <app-custom-icons id="return-selector-button" [type]="iconTypes.ARROW_DOWN_ICON" (click)="triggerSelect()"></app-custom-icons>-->
                  <cx-form-errors [control]="orderReturnForm.get('issueCategory')"></cx-form-errors>
                </label>
              </div>
            </div>
          </div>
          @if (!(validate | async)) {
            <button type="button" (click)="onValidate()" class="btn btn-black ml-3 mt-3">
              {{ 'orderReturn.validate' | cxTranslate }}
            </button>
          }
          @if (validate | async) {
            @if (infobox$ | async; as component) {
              <app-custom-infoboxform [item]="component" [visible]="infoboxVisible"></app-custom-infoboxform>
            }
            <div class="col-md-12 pr-0 mt-5 container-check-box">
              @for (issueCategory of category.entities?.value?.issueCategories; track issueCategory; let i = $index) {
                @if (issueCategory?.subCategory?.length) {
                  <div class="subcategories form-group radio-inline d-flex radio-buttons-form">
                    @for (issueSubCategory of issueCategory?.subCategory; track issueSubCategory; let i = $index) {
                      @if (issueCategory.code === selectedCategoryCode) {
                        <div class="subcategories-item">
                          <span class="form-check">
                            <label class="checkbox">
                              <input
                                class="form-check-input"
                                role="radio"
                                type="radio"
                                name="c4cSubCategory"
                                formControlName="c4cSubCategory"
                                [value]="issueSubCategory.code"
                                (change)="infoboxVisible = issueSubCategory.code === 'SO_YOUR_RETURN'"
                              />
                              @if (issueSubCategory.name) {
                                <div>
                                  {{ issueSubCategory.name }}
                                </div>
                              }
                            </label>
                            @if (issueSubCategory.description) {
                              <div class="sub-label">
                                @if (issueSubCategory.code === 'SO_YOUR_RETURN') {
                                  <a (click)="infoboxVisible = !infoboxVisible">{{ issueSubCategory.description }}</a>
                                } @else {
                                  <div [innerHTML]="'common.moreInfoOrderReturn' | cxTranslate"></div>
                                  <!--{{issueSubCategory.description}}-->
                                }
                              </div>
                            }
                            <cx-form-errors [control]="orderReturnForm.get('c4cSubCategory')"></cx-form-errors>
                          </span>
                        </div>
                      }
                    }
                  </div>
                }
              }
            </div>
            <div class="row col-sm-12 pr-0 mt-3 form-below">
              <div class="col-sm-6 input-field">
                <div class="form-group">
                  <label>
                    <span class="label-content mandatory">{{ 'orderReturn.name' | cxTranslate }}</span>
                    <input class="form-control" type="text" name="fullName" formControlName="fullName" />
                    <cx-form-errors [control]="orderReturnForm.get('fullName')"></cx-form-errors>
                  </label>
                </div>
              </div>
              <div class="col-sm-6 pr-0 input-field">
                <div class="form-group">
                  <label>
                    <span class="label-content mandatory">{{ 'orderReturn.phone' | cxTranslate }}</span>
                    <input class="form-control" type="text" name="phone" formControlName="phone" />
                    <cx-form-errors [control]="orderReturnForm.get('phone')"></cx-form-errors>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <label>
                  <span class="label-content mandatory">{{ 'orderReturn.message' | cxTranslate }}</span>
                  <div class="textarea-wrapper">
                    <div
                      class="textarea-placeholder"
                      [innerHTML]="'forms.textSubcategories.' + selectedCategoryCode | cxTranslate"
                      [class.filled]="orderReturnForm.get('message').value.length < 0"
                    ></div>
                    <textarea
                      class="form-control description-text"
                      type="text"
                      name="message"
                      [class.filled]="orderReturnForm.get('message').value.length > 0"
                      formControlName="message"
                    >
                    </textarea>
                  </div>
                  <cx-form-errors [control]="orderReturnForm.get('message')"></cx-form-errors>
                </label>
              </div>
            </div>
            <div class="form-group col-md-12">
              <app-custom-file-uploader [label]="'forms.contactUs.fileAddImage' | cxTranslate" [formGroup]="orderReturnForm" [required]="fileRequired" [maxFileSize]="5120">
              </app-custom-file-uploader>
            </div>
            <div class="legal-text info-text-bottom col-sm-12">
              <span [innerHTML]="'forms.orderReturn.legalText' | cxTranslate"></span>
              <a class="link-terms" [routerLink]="{ cxRoute: 'termsAndConditions' } | cxUrl" documentType="_blank">
                {{ 'orderReturn.legalText2' | cxTranslate }}
              </a>
            </div>
            <div class="form-group checkbox-bottom">
              <div class="form-check">
                <label class="checkbox">
                  <input type="checkbox" name="privacyPolicy" formControlName="privacyPolicy" />
                  <span class="form-check-label mandatory">
                    <span [innerHTML]="'forms.orderReturn.termsAndConditions' | cxTranslate"></span>
                    <a [routerLink]="{ cxRoute: 'termsAndConditions' } | cxUrl" documentType="_blank">
                      {{ 'orderReturn.termsAndConditions2' | cxTranslate }}
                    </a>
                  </span>
                </label>
              </div>
              <cx-form-errors [control]="orderReturnForm.get('privacyPolicy')"></cx-form-errors>
            </div>
            <div class="row col-md-12 m-0 btn-margin">
              <button type="submit" class="btn btn-block btn-black col-md-5" [disabled]="submitted$ | async">
                {{ 'orderReturn.send' | cxTranslate }}
              </button>
            </div>
          }
        </form>
      }
    </div>
  </div>
</div>
